const shadows = [
  'none',
  '0 1px 4px 0 rgba(12, 12, 13, 0.1)', // 10 in Zeplin
  '0 2px 8px 0 rgba(12, 12, 13, 0.15)', // 20 in Zeplin
  '0 4px 12px 0 rgba(12, 12, 13, 0.2)', // 30 in Zeplin
  '0 8px 16px 0 rgba(0, 0, 0, 0.25)', // 40 in Zeplin
]

export default shadows
